module.exports = __webpack_public_path__ + "static/GMCC-Member-Logo-white-a9c43ffd23cbd95f8a4fc697d9426fd7.png";